var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c(
            "div",
            { staticClass: "mb-3 total_figures flex align-items-stretch" },
            [
              _c("div", [
                _c("p", [
                  _c("strong", [_vm._v(_vm._s(_vm.totalData.websites))]),
                  _vm._v(" - линков на проверку"),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v(_vm._s(_vm.totalData.checks))]),
                  _vm._v(" - просканировано"),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c(
                    "strong",
                    {
                      staticClass: "badge badge-primary pointer",
                      on: {
                        click: function ($event) {
                          return _vm.updateFilter(3)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.totalData.pass))]
                  ),
                  _vm._v(" -\n            прошли проверку"),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c(
                    "strong",
                    {
                      staticClass: "badge badge-primary pointer",
                      on: {
                        click: function ($event) {
                          return _vm.updateFilter(4)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.totalData.errors))]
                  ),
                  _vm._v(" -\n            ошибок при проверке"),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c(
                    "strong",
                    {
                      staticClass: "badge badge-danger pointer",
                      on: {
                        click: function ($event) {
                          return _vm.updateFilter(5)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.totalData.blocked))]
                  ),
                  _vm._v(" -\n            ограничения РКН"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ml-3" }, [
                _c("p", [
                  _vm._v("проверка: "),
                  _c("strong", [_vm._v(_vm._s(_vm.getDateOfCheck()))]),
                ]),
                _vm._v(" "),
                _vm.filter && _vm.filter.active
                  ? _c(
                      "div",
                      [
                        _vm._l(
                          _vm.filter.usedFilters,
                          function (usedFilter, i) {
                            return _c(
                              "span",
                              { staticClass: "badge badge-info" },
                              [_vm._v(_vm._s(usedFilter))]
                            )
                          }
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-default",
                            on: {
                              click: function ($event) {
                                return _vm.updateFilter(0)
                              },
                            },
                          },
                          [_vm._v("сбросить фильтр")]
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ml-3 text-right", staticStyle: { flex: "1" } },
                [
                  _c("div", { staticClass: "form-group flex" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.newRecord.project_id,
                            expression: "newRecord.project_id",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.newRecord,
                              "project_id",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      _vm._l(_vm.projects, function (project) {
                        return _c(
                          "option",
                          { domProps: { value: project.id } },
                          [_vm._v(_vm._s(project.title))]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.newRecord.type,
                            expression: "newRecord.type",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.newRecord,
                              "type",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      _vm._l(_vm.types, function (type, id) {
                        return _c("option", { domProps: { value: id } }, [
                          _vm._v(_vm._s(type)),
                        ])
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newRecord.url,
                        expression: "newRecord.url",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      placeholder: "Новый url для проверки без http!",
                    },
                    domProps: { value: _vm.newRecord.url },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.newRecord, "url", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success mt-1",
                      on: { click: _vm.saveNewRecord },
                    },
                    [_vm._v("Сохранить новый")]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-info",
                on: { click: _vm.getRecords },
              },
              [_vm._v("Обновить список")]
            ),
          ]),
          _vm._v(" "),
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: { loading: _vm.loading, color: _vm.loadingColor },
          }),
          _vm._v(" "),
          _vm.totalData.websites
            ? _c("table", { staticClass: "table table-sm table-hover mt-0" }, [
                _vm._m(0),
                _vm._v(" "),
                _vm.filter && _vm.filter.active
                  ? _c(
                      "tbody",
                      [
                        _vm._l(_vm.filter.websites, function (domain, i) {
                          return [
                            _c("TableTrCheckUrl", {
                              key: i,
                              attrs: {
                                domain: domain,
                                check: _vm.checks[domain.id],
                                updateRecord: (action, r) =>
                                  _vm.updateRecord(action, r),
                                types: _vm.types,
                              },
                            }),
                          ]
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.filter
                  ? _c(
                      "tbody",
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _vm._l(_vm.getSeoDomains(), function (domain, index) {
                          return [
                            _c("TableTrCheckUrl", {
                              key: index,
                              attrs: {
                                domain: domain,
                                check: _vm.checks[domain.id],
                                updateRecord: (action, r) =>
                                  _vm.updateRecord(action, r),
                                types: _vm.types,
                              },
                            }),
                          ]
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.projects, function (project, index) {
                          return project.web_sites && project.web_sites.length
                            ? [
                                _vm._l(
                                  _vm.getWebSitesByType(project.web_sites),
                                  function (webSite, i) {
                                    return [
                                      i === 0
                                        ? _c("tr", [
                                            _c("td", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex justify-content-between",
                                                },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(project.title)
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("td", {
                                              attrs: { colspan: "20" },
                                            }),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("TableTrCheckUrl", {
                                        attrs: {
                                          domain: webSite,
                                          check: _vm.checks[webSite.id],
                                          updateRecord: (action, r) =>
                                            _vm.updateRecord(action, r),
                                          types: _vm.types,
                                        },
                                      }),
                                    ]
                                  }
                                ),
                              ]
                            : _vm._e()
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("URL страницы")]),
        _vm._v(" "),
        _c("th", [_vm._v("Тип")]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Информация")]),
        _vm._v(" "),
        _c("th", [_vm._v("Не информировать")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { attrs: { colspan: "20" } }, [
        _c("strong", [_vm._v("SEO домены")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }